interface LogoProps {
  /** "dark" = testo scuro su sfondo chiaro (navbar), "light" = testo bianco su sfondo scuro (footer) */
  variant?: "dark" | "light";
  className?: string;
}

export function Logo({ variant = "dark", className = "" }: LogoProps) {
  return (
    <div
      className={`${variant === "light" ? "rounded-xl bg-white px-3 py-2" : ""} ${className}`}
      data-testid="brand-logo"
    >
      <img
        src="/ovvo-camping-logo-header.png"
        alt="OVVO Camping"
        className="h-10 md:h-11 w-auto"
        width="658"
        height="300"
      />
    </div>
  );
}
